const selector = '#bss-b2b-net-term-button-wrapper';
let elapsed = 0;
const intervalTime = 100;

const interval = setInterval(() => {
  const element = document.querySelector(selector);
  elapsed += intervalTime;

  if (element) {
    clearInterval(interval);
      const isCart = window.location.pathname === '/cart';
    const nt = document.querySelector(selector);
      const checkoutBtn = document.querySelectorAll(`[name="checkout"]`);
    document.querySelector('#bss-b2b-net-term-button')?.setAttribute("type", "button");
      if(isCart) {
     checkoutBtn[1].insertAdjacentElement("afterEnd", nt)
      }else {
          checkoutBtn[0].insertAdjacentElement("afterEnd", nt)
      }
  }

  if (elapsed >= 6000) {
    clearInterval(interval);
  }
}, intervalTime);